import data from './sample.json';
import { observable } from 'mobx';
import { Question } from 'src/stores/Question';
import { Paragraph } from 'src/stores/Paragraph';
import { Answer } from 'src/stores/Answer';

export class Store {
    public questionStore: any;
    public paragraphs: Paragraph[];
    public answers: Answer[];
    @observable public questions: Question[];
    @observable public sampleMethod: string; //'best'|'worst'|'rand';
    @observable public displayOption: string; //'writeup'|'visualization'|'rand';
    
    constructor () {
        this.displayOption = 'writeup';
        this.sampleMethod = 'worst';
        this.paragraphs = data.paragraphs.map((p: any) => new Paragraph(p.aid, p.pid, p.doc));
        this.answers = data.answers.map((a: any) => 
            new Answer( a.model, a.qid, a.sid, a.is_groundtruth, 
                        a.span_start, a.span_end, a.doc, a.perform));
        this.questionStore = data.questions
            .map((q: any) => new Question(q.qid, q.aid, q.pid, q.doc, q.attention, q.perform));
        this.questions = this.sampleQuestions(this.questionStore);
    }


    /**
     * Build a sampler to strategically get some instance to look at
     * @param questionStore: Question[] total set of questions.
     * @param nSamples: number, the number of questions
     * @return a list of questions
     */
    public sampleQuestions(questionStore: Question[], nSamples: number = 10): Question[] {
        return questionStore.slice()
            .sort((a: Question, b: Question): number => {
                const deltaF1 = b.perform.f1 - a.perform.f1;
                const deltaConfidence = b.perform.confidence - a.perform.confidence;
                switch (this.sampleMethod) {
                    case 'worst': return deltaF1 !== 0 ? -1 * deltaF1 : deltaConfidence;
                    case 'best': return deltaF1 !== 0 ? deltaF1 : deltaConfidence;
                    case 'rand': case 'default': return 0.5 - Math.random(); 
                }
                return 0.5 - Math.random(); 
            })
            .slice(0, nSamples);
    }

    /**
     * Filter the paragraph based on aid and pid
     * @param aid <int> article ids.
     * @param pid <int> paragraph id.
     * @return a list of paragraphs instances associated with the ids.
     */
    public filterParagraph (aid: number, pid: number): Paragraph[] {
        return this.paragraphs.filter((p: Paragraph) => {
            return p.aid === aid && p.pid === pid;
        });
    }

    /**
     * Filter the answer based on qid.
     * @param qid <string> the question id
     * @return a list of answer instances associated with the qid.
     */
    public filterAnswer (qid: string): Answer[] {
        return this.answers.filter((a: Answer) => a.qid === qid);
    }
}

export const store = new Store();


// WEBPACK FOOTER //
// ./src/stores/Store.ts